import { getFormatedUtcDate, getFormattedUtcDateInk, getFormattedUtcDateSnap } from "./date";
import { translate } from "i18n";

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export function formatResampling(pace: number): string {
  return pace.toString();
}
export function convertAndCapitalize(arg: boolean): string {
  const converted = arg.toString();
  return converted.charAt(0).toUpperCase() + converted.slice(1);
}

export function getWatermarkTimeStamp(timestamp: Date): string {
  const timestampAsDate = new Date(timestamp);
  if (timestampAsDate.getUTCFullYear() > 1970) {
    return getFormatedUtcDate(timestamp);
  }
  return "N/A";
}
export function getWatermarkTimeStampSnap(timestamp: Date): string {
  const timestampAsDate = new Date(timestamp);
  if (timestampAsDate.getUTCFullYear() > 1970) {
    return getFormattedUtcDateSnap(timestamp);
  }
  return "N/A";
}

export function getWatermarkTimeStampInk(timestamp: Date): string {
  const timestampAsDate = new Date(timestamp);
  if (timestampAsDate.getUTCFullYear() > 1970) {
    return getFormattedUtcDateInk(timestamp);
  }
  return "N/A";
}

export function formatWatermarkId(wmk: number): string {
  return wmk > 0 ? wmk.toString() : "N/A";
}

export function getPayloadTypeTxt(payloadType: number): string {
  if (payloadType === 0) {
    return translate("detected watermark type");
  }
  if (payloadType === 1) {
    return translate("not detected watermark type");
  }
  if (payloadType === 2) {
    return translate("detected unidentified watermark type");
  }
  return "N/A";
}
